import { Module } from 'vuex';
import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';
import { AnnouncementState, RootState } from '../types';

const namespaced: boolean = true;

export const state: AnnouncementState = {
	announcements: []
};

export const Announcements: Module<AnnouncementState, RootState> = {
	namespaced,
	state,
	getters,
	mutations,
	actions
};

export default Announcements;